import React from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { GUOMEI, adsNotes } from '../guomeiContent';

const AdsNotes = () => (
  <Box
    component="section"
    id="aclaraciones"
    py={{ xs: 5, md: 7 }}
    px={{ xs: 2.5, sm: 4, md: 7 }}
    sx={{
      background: `linear-gradient(165deg, ${GUOMEI.oceanDeep} 0%, ${GUOMEI.ocean} 100%)`,
      color: GUOMEI.white,
    }}
  >
    <Box maxWidth={1100} mx="auto">
      <Typography
        sx={{
          fontFamily: '"Outfit", sans-serif',
          fontWeight: 700,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          fontSize: '0.7rem',
          color: 'rgba(255,255,255,0.65)',
          mb: 1,
        }}
      >
        {adsNotes.overline}
      </Typography>
      <Typography
        component="h2"
        sx={{
          fontFamily: '"Fraunces", "Georgia", serif',
          fontWeight: 700,
          fontSize: { xs: '1.6rem', md: '2rem' },
          mb: { xs: 3, md: 3.5 },
        }}
      >
        {adsNotes.title}
      </Typography>

      <Grid container spacing={2.5}>
        {adsNotes.items.map((item, index) => (
          <Grid item xs={12} md={4} key={item.id}>
            <Box
              height="100%"
              p={2.5}
              borderRadius={2}
              sx={{ bgcolor: 'rgba(255,255,255,0.06)' }}
            >
              <Typography
                sx={{
                  fontFamily: '"Outfit", sans-serif',
                  fontWeight: 800,
                  fontSize: '0.75rem',
                  color: GUOMEI.sunsetSoft,
                  mb: 1,
                }}
              >
                0{index + 1}
              </Typography>
              <Typography
                component="h3"
                sx={{
                  fontFamily: '"Outfit", sans-serif',
                  fontWeight: 800,
                  fontSize: '1.2rem',
                  mb: 1,
                }}
              >
                {item.title}
              </Typography>
              <Typography
                sx={{
                  fontFamily: '"Source Sans 3", sans-serif',
                  color: 'rgba(255,255,255,0.88)',
                  lineHeight: 1.5,
                  fontSize: '1rem',
                }}
              >
                {item.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  </Box>
);

export default AdsNotes;
